// extracted by mini-css-extract-plugin
module.exports = {"vslContainer":"VSL_vslContainer___Z1Y1","videoContainer":"VSL_videoContainer__7MsUJ","responsiveIframe":"VSL_responsiveIframe__JnCR5"};